/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import {
  PaginationWrapper,
  PaginatorButtonNew,
  PaginatedArrow,
  ContentContainer,
  ContentString,
} from './plpShowingResultPaginator.styles';
import { getLabelFromCopyOrFromTranslation, renderLabel } from '../../../../utils/labels/labelUtilty';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Paginator = (props) => {
  const {
    currentPage: selectedPage = 1,
    totalCount,
    pageSize,
    onPageChange,
    trackClick,
    isNewNavigationImagesEnabled,
    processedBreadCrumbs,
  } = props;
  const slpLabels = getLabelFromCopyOrFromTranslation('SLPs.SLPs_Sub')
  // compute the total number of pages    
  const totalPages = Math.ceil(totalCount / pageSize);
  const [pageNumber, setPageNumber] = useState(selectedPage);
  const [isDisabled, setIsDisabled] = useState(totalPages < 2);

  useEffect(() => {
    if (pageNumber !== selectedPage) {
      setPageNumber(selectedPage);
    }
    setIsDisabled(totalPages < 2);
  }, [selectedPage, totalPages]);

  const updatePage = ({ value: page }) => {
    setPageNumber(page);
    setTimeout(() => {
      onPageChange(page);
    }, 10);
  };
  const getPageNavigationText = () => {
    const breadCrumbNames = processedBreadCrumbs?.map((breadCrumb) =>
      breadCrumb?.displayName?.toLowerCase()
    );
    if (isNewNavigationImagesEnabled) {
      return `topmenu-withimage-${breadCrumbNames?.join('-')}`;
    }
    return `topmenu-${breadCrumbNames?.join('-')}`;
  };

  const analyticsOnClick = (type) => {
    const pageNavigationText = getPageNavigationText();
    trackClick({
      plp_pagination_cd153: `${pageNavigationText}|${type}`,
    });
  };

  const increment = (event) => {
    if (pageNumber + 1 <= totalPages) {
      analyticsOnClick('next');
      updatePage({ value: pageNumber + 1 });
    }
    event?.target?.blur();
  };

  const decrement = (event) => {
    if (pageNumber - 1 >= 1) {
      analyticsOnClick('previous');
      updatePage({ value: pageNumber - 1 });
    }
    event?.target?.blur();
  };

  const from = (pageNumber - 1) * pageSize + 1;
  const productCount = (pageNumber - 1) * pageSize + pageSize;
  const till = totalCount && totalCount > productCount ? productCount : totalCount;
  const resultsString = totalCount > 1 ? renderLabel(slpLabels.lbl_results, 'lbl_results') : renderLabel(slpLabels.lbl_result, 'lbl_result');
  const displayString = `${renderLabel(slpLabels.lbl_showing_x_items, 'lbl_showing_x_items')} ${from} - ${till}  ${renderLabel(slpLabels.lbl_range_of,'lbl_range_of') } ${totalCount} ${resultsString}`;
  return (
    <PaginationWrapper>
      <PaginatorButtonNew
        onClick={decrement}
        className="prev-button"
        disabled={pageNumber === 1 || isDisabled}
      >
        <PaginatedArrow className="prev" disabled={pageNumber === 1 || isDisabled} />
      </PaginatorButtonNew>
      <ContentContainer>
        <ContentString>{displayString}</ContentString>
      </ContentContainer>
      <PaginatorButtonNew
        onClick={increment}
        className="next-button"
        disabled={pageNumber === totalPages || isDisabled}
      >
        <PaginatedArrow className="next" disabled={pageNumber === totalPages || isDisabled} />
      </PaginatorButtonNew>
    </PaginationWrapper>
  );
};

export default Paginator;
